import styled from 'styled-components';

import { Spacer } from '@ontruck/orc';

const LoadingWrapper = styled(Spacer).attrs(() => ({ mLeft: 'S' }))`
  width: 25px;
  opacity: 0;
`;

export { LoadingWrapper };
